import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from 'src/infra/stores/store';
import { BilledEntityItem } from 'src/use-cases/settings/useBilledEntities';

export interface IBilledEntitiesState {
  selectedEntities: BilledEntityItem[];
}

const initialState: IBilledEntitiesState = {
  selectedEntities: [],
};

const billedEntitiesSlice = createSlice({
  name: 'billedEntities',
  initialState,
  reducers: {
    setSelectedBilledEntities: (state, action: PayloadAction<BilledEntityItem[]>) => {
      state.selectedEntities = action.payload;
    },
    clearSelectedBilledEntities: (state) => {
      state.selectedEntities = [];
    },
  },
});

export const { setSelectedBilledEntities, clearSelectedBilledEntities } = billedEntitiesSlice.actions;

// Selectors
export const selectSelectedBilledEntities = (state: IRootState) => state.billedEntities.selectedEntities;

export default billedEntitiesSlice.reducer;
